// CaptchaSimple.js — Captcha propio de la plataforma, sin servicios externos.
//
// Pide al servidor una operación sencilla («8 + 9») con su token firmado
// (api/captcha.php) y devuelve al formulario el token y lo que escribe la
// persona. Se usa cuando el proyecto no tiene claves de Cloudflare Turnstile,
// para que los formularios públicos no queden abiertos a envíos automáticos.
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { captchaService } from '../../../services/api';

const Caja = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.45em;
  .pregunta { font-weight: 600; font-size: 17px; text-align: center; letter-spacing: .2px; }
  .pregunta .req { color: #f0abfc; margin-left: 4px; }
  .otra { align-self: center; border: none; background: none; padding: 0; font-family: inherit; font-size: 14px;
          color: ${p => p.$color}; text-decoration: underline; cursor: pointer; }
  .otra:hover { color: #fff; }
`;

const CaptchaSimple = ({ onCambio, color = '#ddcafc', etiqueta = '¿Cuánto es', reinicio = 0 }) => {
  const [reto, setReto] = useState(null);
  const [valor, setValor] = useState('');

  const pedir = useCallback(() => {
    captchaService.obtener()
      .then(r => { setReto(r.data); setValor(''); onCambio?.({ token: r.data?.token || '', respuesta: '' }); })
      .catch(() => setReto(null));
  // `onCambio` cambia en cada render del formulario; el reto solo se pide al montar o al reiniciar.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { pedir(); }, [pedir, reinicio]);

  if (!reto) return null;

  return (
    <Caja $color={color}>
      <label className="pregunta" htmlFor="captcha_respuesta">
        <span>{etiqueta} {reto.pregunta}?<span className="req" aria-hidden="true">*</span></span>
      </label>
      <input
        id="captcha_respuesta"
        inputMode="numeric"
        autoComplete="off"
        value={valor}
        onChange={e => {
          const v = e.target.value.replace(/[^\d-]/g, '');
          setValor(v);
          onCambio?.({ token: reto.token, respuesta: v });
        }}
        required
      />
      <button type="button" className="otra" onClick={pedir}>Otra operación</button>
    </Caja>
  );
};

export default CaptchaSimple;
